// extracted by mini-css-extract-plugin
module.exports = {"images":"audioPlayerImage-module--images--JX4s9"};